<script>
  // import ColorShade from "./components/ColorShade.svelte";
  import ColorShadeGroup from "./components/ColorShadeGroup.svelte";
  import ColorFamilyPaletteGenerator from "./components/ColorFamilyPaletteGenerator.svelte";
  import GradientBackgroundGroup from "./components/GradientBackgroundGroup.svelte";
  import GradientTextGroup from "./components/GradientTextGroup.svelte";
  import ColorMixer from "./components/ColorMixer.svelte";
  import chroma from "chroma-js";
  import ColorMixManager from "./components/ColorMixManager.svelte";

  let activeView = 0;

  const switchTo = (index) => {};

  let redData = [
    "#AA0000",
    "#fd5c63",
    "#E32636",
    "#E52B50",
    "#FBCEB1",
    "#FF033E",
    "#C60C30",
    "#BA0021",
    "#800020",
    "#660000",
    "#FF003F",
    "#FF004F",
    "#FFA07A",
    "#F08080",
    "#A45A52",
    "#DB7093",
    "#ED2939",
    "#FF6347",
    "#F88379",
    "#FF0000",
    "#722F37",
  ];
  let blueData = [
    "#7cb9e8",
    "#00308f",
    "#72a0c1",
    "#002d62",
    "#007fff",
    "#0066b2",
    "#95d7d7",
    "#0cafff",
    "#8c99ee",
    "#3f00ff",
    "#2d01b4",
    "#04011f",
    "#3377ff",
    "#1c0d4a",
    "#363147",
    "#330aff",
    "#0d0034",
    "#3377f9",
    "#473c6e",
    "#5588bb",
  ];
  let purpleData = [
    "#4b0082",
    "#ff60ff",
    "#dda0dd",
    "#800080",
    "#d8bfd8",
    "#ee82ee",
    "#eb65eb",
    "#ca70ca",
    "#ffd0ff",
    "#ef02ff",
    "#8f4c8f",
    "#5c3c5c",
    "#581958",
    "#f9609f",
    "#441f44",
    "#8f4c8f",
    "#630063",
    "#a00078",
    "#e4aad5",
    "#be008f",
  ];

  let greenData = [
    "#32de84",
    "#48AF44",
    "#87A96B",
    "#568203",
    "#006A4E",
    "#66FF00",
    "#00FF00",
    "#17B169",
    "#00563B",
    "#ACE1AF",
    "#8FBC8B",
    "#004953",
    "#ADFF2F",
    "#008200",
    "#49796B",
    "#A9BA9D",
    "#18453B",
    "#808000",
    "#98FB98",
    "#00674b",
  ];

  let gradientBackgroundDataGroup1 = [
    "background: linear-gradient(to top, #c7e9ff 0%, #e2ebf0 100%);",
    "background:linear-gradient(to top, #e6f2ab 0%, #92dcbd 100%);",
    "background:linear-gradient(to top, #a8d2ed 0%, #e2ebf0 100%);",
    "background:linear-gradient(to top, #cfd9df 0%, #c3ebc5 100%);",
    "background:linear-gradient(to bottom, #f59c79 0%, #e2ebf0 100%);",
    "background:linear-gradient(to bottom, #71b3dc 0%, #bccfd9 100%);",
    "background:linear-gradient(to bottom, #cfd9df 0%, #c467fa 100%);",
    "background:linear-gradient(to bottom, #cfd9df 0%, #b0bfc8 100%);",
    "background:linear-gradient(to right, #c8ed6c 0%, #e2ebf0 100%);",
    "background:linear-gradient(to right, #cfd9df 0%, #85d4ff 100%);",
    "background:linear-gradient(to right, #aebec7 0%, #a0f5ae 100%);",
    "background:linear-gradient(to right, #cfd9df 0%, #f39186 100%);",
    "background:linear-gradient(to left, #d4df6c 0%, #a3dfffbd 100%);",
    "background:linear-gradient(to left, #cfd9df 0%, #bddced 100%);",
    "background:linear-gradient(to left, #afd2e8 0%, #afb2b3 100%);",
    "background:linear-gradient(to left, #c3e2bf 0%, #ffb8eb 100%);",
  ];

  let gradientBackgroundDataGroup2 = [
    "background: linear-gradient(90deg,#8dd8ed 0%,#7fda88 100%);",
    "background: linear-gradient(-90deg,#85fddd 0%,#f48ae9 100%);",
    "background: linear-gradient(45deg,#8dd6ea 0%,#529f5a 100%);",
    "background: linear-gradient(-45deg,#d3f78a 0%,#90e599 100%);",
    "background: linear-gradient(120deg,#9cbdc6 0%,#fefc92 100%);",
    "background: linear-gradient(-120deg,#85c584 0%,#9492fe 100%);",
    "background: linear-gradient(270deg,#97ccda 0%,#54f364 100%);",
    "background: linear-gradient(-270deg,#9e5f8f 0%,#767ee3 100%);",
    "background: linear-gradient(135deg,#bbdbe3 0%,#f19db9 100%);",
    "background: linear-gradient(-135deg,#f1bd79 0%,#9d7397 100%);",
    "background: linear-gradient(188deg,#ffffff55 0%,#e09696 100%);",
    "background: linear-gradient(220deg,#e8be6b 0%,#92fe9d 100%);",
    "background: linear-gradient(-311deg,#ffffff55 0%,#fd97de 100%);",
    "background: linear-gradient(123deg,#ffffff55 0%,#4ee0b6 100%);",
    "background: linear-gradient(225deg,#ffffff55 0%,#bc5af1 100%);",
    "background: linear-gradient(177deg,#b1fa98 0%,#b6689f 100%);",
  ];

  let gradientBackgroundDataGroup3 = [
    "background: linear-gradient(90deg,#c5e7f0 0%,#ffffff55 50% ,#30f744 100%);",
    "background: linear-gradient(90deg,#acbfc4 0%,#6dc8e1 60% ,#51c6f5 90%);",
    "background: linear-gradient(90deg,#718388 0%,#a7e9fb 33% ,#72ff80 196%);",
    "background: linear-gradient(90deg,#e7cc62 0%,#f8f880 20% ,#ff8b56 170%);",
    "background: linear-gradient(-90deg,#c5e7f0 0%,#ffffff55 50% ,#30f744 100%);",
    "background: linear-gradient(-90deg,#acbfc4 0%,#6dc8e1 60% ,#51c6f5 90%);",
    "background: linear-gradient(-90deg,#718388 0%,#a7e9fb 33% ,#72ff80 196%);",
    "background: linear-gradient(-90deg,#e7cc62 0%,#f8f880 20% ,#ff8b56 170%);",
    "background: linear-gradient(45deg,#c5e7f0 0%,#ffffff55 50% ,#30f744 100%);",
    "background: linear-gradient(45deg,#acbfc4 0%,#6dc8e1 60% ,#51c6f5 90%);",
    "background: linear-gradient(45deg,#718388 0%,#a7e9fb 33% ,#72ff80 196%);",
    "background: linear-gradient(45deg,#e7cc62 0%,#f8f880 20% ,#ff8b56 170%);",
    "background: linear-gradient(-45deg,#c5e7f0 0%,#ffffff55 50% ,#30f744 100%);",
    "background: linear-gradient(-45deg,#acbfc4 0%,#6dc8e1 60% ,#51c6f5 90%);",
    "background: linear-gradient(-45deg,#718388 0%,#a7e9fb 33% ,#72ff80 196%);",
    "background: linear-gradient(-45deg,#e7cc62 0%,#f8f880 20% ,#ff8b56 170%);",
  ];
  let gradientBackgroundDataGroup4 = [
    "background: linear-gradient(to top,#ffffff55 0%,#e2eaa5 50% ,#92fe9d 100%);",
    "background: linear-gradient(to top,#ffffff55 10%,#e2eaa5 44% ,#92fe9d 98%);",
    "background: linear-gradient(to top,#ffffff55 0%,#e2eaa5 55% ,#92fe9d 100%);",
    "background: linear-gradient(to top,#ffffff55 5%,#e2eaa5 78% ,#92fe9d 100%);",
    "background: linear-gradient(to bottom,#88f4a1 0%,#f1f9b3 50% ,#e280c3 100%);",
    "background: linear-gradient(to bottom,#88f4a1 10%,#f1f9b3 44% ,#e280c3 98%);",
    "background: linear-gradient(to bottom,#88f4a1 0%,#f1f9b3 55% ,#e280c3 100%);",
    "background: linear-gradient(to bottom,#88f4a1 5%,#f1f9b3 78% ,#e280c3 100%);",
    "background: linear-gradient(to right,#88edf4 0%,#d0e340 50% ,#72c6e7 100%);",
    "background: linear-gradient(to right,#88edf4 10%,#d0e340 44% ,#72c6e7 98%);",
    "background: linear-gradient(to right,#88edf4 0%,#d0e340 55% ,#72c6e7 100%);",
    "background: linear-gradient(to right,#88edf4 5%,#d0e340 78% ,#72c6e7 100%);",
    "background: linear-gradient(to left,#fbbb7c 0%,#b3f1f1 50% ,#ffa0c9 100%);",
    "background: linear-gradient(to left,#fbbb7c 10%,#b3f1f1 44% ,#ffa0c9 98%);",
    "background: linear-gradient(to left,#fbbb7c 0%,#b3f1f1 55% ,#ffa0c9 100%);",
    "background: linear-gradient(to left,#fbbb7c 5%,#b3f1f1 78% ,#ffa0c9 100%);",
  ];
  let gradientBackgroundDataGroup5 = [
    "background:radial-gradient(circle at 50% 0%, rgb(246, 102, 102),rgb(232, 246, 102));",
    "background:radial-gradient(circle at 50% 20%, rgba(249, 59, 195, 0.635),rgb(234, 66, 66));",
    "background:radial-gradient(circle at 100% 40%, rgba(207, 53, 53, 0.533),rgb(225, 9, 214));",
    "background:radial-gradient(circle at 60% 7%, rgb(233, 248, 67),rgb(246, 102, 102));",
    "background:radial-gradient(circle at 50% 0%, rgb(94, 36, 36),rgb(14, 178, 233));",
    "background:radial-gradient(circle at 50% 8%, rgba(57, 183, 232, 0.772),rgb(117, 195, 100));",
    "background:radial-gradient(circle at 50% 0%, rgb(174, 197, 40),rgb(246, 102, 102));",
    "background:radial-gradient(circle at 50% 3%, rgb(122, 38, 206),rgb(28, 228, 182));",
    "background:radial-gradient(circle at 50% 10%, rgb(30, 173, 123),rgb(110, 101, 101));",
    "background:radial-gradient(circle at 90% 9%, rgba(133, 220, 113, 0.889),rgb(246, 102, 102));",
    "background:radial-gradient(circle at 80% 0%, rgba(231, 10, 10, 0.448),rgb(117, 246, 102));",
    "background:radial-gradient(circle at 50% 0%, rgb(77, 38, 217),rgb(246, 102, 102));",
    "background:radial-gradient(circle at 70% 8%, rgb(66, 48, 96),rgb(111, 245, 171));",
    "background:radial-gradient(circle at 50% 0%, rgb(246, 102, 102),rgb(109, 107, 193));",
    "background:radial-gradient(circle at 80% 28%, rgb(242, 145, 35),rgb(246, 102, 102));",
    "background:radial-gradient(circle at 90% 35%, rgba(225, 123, 233, 0.776),rgb(234, 178, 12));",
  ];
  let gradientBackgroundDataGroup6 = [
    "background:repeating-radial-gradient( circle  at center left, rgba(83,138,214,1) 0%,rgba(134,231,214,1) 12% ) ;",
    "background:repeating-radial-gradient( circle  at center right, rgba(123,138,214,1) 0%,rgba(134,231,66,1) 12% ) ;",
    "background:repeating-radial-gradient( circle  at center bottom, rgba(123,138,66,1) 0%,rgba(55,231,66,1) 12% ) ;",
    "background:repeating-radial-gradient( circle  at center top, rgba(123,138,66,1) 0%,rgba(55,231,66,1) 12% ) ;",
    "background:repeating-radial-gradient( ellipse  at center center, rgba(123,138,66,1) 0%,rgba(55,53,66,1) 12% ) ;",
    "background:repeating-radial-gradient( circle  at left top, rgba(123,138,66,1) 0%,rgba(55,53,66,1) 12% ) ;",
    "background:repeating-radial-gradient( ellipse  at right top, rgba(123,138,214,1) 0%,rgba(55,53,214,1) 12% ) ;",
    "background:repeating-radial-gradient( circle  at left bottom, rgba(83,138,214,1) 0%,rgba(134,53,214,1) 12% ) ;",
    "background:repeating-radial-gradient( circle  at right bottom, rgba(83,138,214,1) 0%,rgba(134,53,214,1) 12% ) ;",
    "background:repeating-radial-gradient( ellipse  at 12% 30%, rgba(83,138,214,1) 0%,rgba(134,231,214,1) 12% ) ;",
    "background:repeating-radial-gradient( circle  at 0% 25%, rgba(83,138,214,1) 0%,rgba(134,231,214,1) 12% ) ;",
    "background:repeating-radial-gradient( ellipse  at 60% 98%, rgba(83,138,214,1) 0%,rgba(134,231,214,1) 12% ) ;",
  ];
  let gradientBackgroundDataPicks = [
    "background: linear-gradient(to right top, #F0B7A1 0%, #8C3310 50%, #752201 51%, #BF6E4E 100%);",
    "background: linear-gradient(90deg, rgba(51,90,27,0.6786064767703957) 2%, rgba(139,90,219,1) 38%, rgba(54,49,125,1) 55%, rgba(72,48,168,1) 67%, rgba(9,9,121,1) 80%, rgba(91,145,155,1) 89%);",
    "background: linear-gradient(90deg,#ffffff55 0%,#92fe9d 100%);",
    "background: linear-gradient(90deg, #3F2B96 0%, #A8C0FF 100%)",
    "background: linear-gradient(90deg,#FDBB2D 0%, #22C1C3 100%)",
    "background: linear-gradient(90deg, #FDBB2D 0%, #3A1C71 100%)",
    "background: linear-gradient(90deg, #efd5ff 0%, #515ada 100%)",
    "background: linear-gradient(90deg,#d53369 0%, #daae51 100%)",
    "background: linear-gradient(90deg, #fcff9e 0%, #c67700 100%)",
    "background: linear-gradient(90deg, #f8ff00 0%, #3ad59f 100%)",
    "background: linear-gradient(90deg,#00d2ff 0%, #3a47d5 100%)",
    "background: linear-gradient(45deg, #85FFBD 0%, #FFFB7D 79%)",
    "background: linear-gradient(90deg, #FAD961 0%, #F76B1C 100%)",
    "background: linear-gradient(45deg,#ff9a9e 0%, #fad0c4 99%, #fad0c4 100%)",
    "background: linear-gradient(to top, #cfd9df 0%,#e2ebf0 100%)",
    "background: linear-gradient(to right, #fa709a 0%, #fee140 100%)",
    "background: linear-gradient(to top, #d299c2 0%, #fef9d7 100%)",
    "background: linear-gradient(to top,#ebc0fd 0%, #d9ded8 100%)",
    "background: linear-gradient(to right, #e4afcb 0%, #b8cbb8 0%, #b8cbb8 0%, #e2c58b 30%, #c2ce9c 64%, #7edbdc 100%)",
    "background: linear-gradient(60deg, #abecd6 0%, #fbed96 100%)",
    "background: linear-gradient(to top, #c71d6f 0%, #d09693 100%)",
    "background: linear-gradient(to top, #0fd850 0%, #f9f047 100%)",
    "background: linear-gradient(to top,#d5dee7 0%, #ffafbd 0%, #c9ffbf 100%)",
    "background: linear-gradient(to top, #d5d447 0%,#f123bd 0%, #c9669f 100%)",
    "background: linear-gradient( to right, transparent, #f123bd ) ,url(rarrow.png)",
    "background: linear-gradient(217deg, rgba(255,0,0,.8), rgba(255,0,0,0) 70.71%)",
    "background:radial-gradient(circle at center center, rgba(225, 123, 233, 0.776),rgba(225, 123, 233, 0.776),rgb(234, 178, 12))",
  ];

  let gradientHotBackgroundDataPicks = [
    "background: repeating-radial-gradient(ellipse at 10% 70%,#339a8a 10%,#cce7d64d 12%);",
    "background: repeating-radial-gradient(ellipse at 10% 84%,#b91aad 11%,#91ffff80 12%);",
    "background: repeating-radial-gradient(ellipse at 44% 84%,#1e794e 11%,#91ffff99 12%);",
    "background: repeating-radial-gradient(ellipse at 30% 82%,#8f00d9 11%,#78ff281a 12%);",
    "background: repeating-radial-gradient(ellipse at 50% 50%,#000000e6 15%,#eaffff33 16%);",
    "background: repeating-radial-gradient(ellipse at 50% 50%,#ff687680 15%,#39ff004d 17%);",
    "background: repeating-radial-gradient(ellipse at 50% 56%,#301800 10%,#52771a33 11%);",
    "background: repeating-radial-gradient(ellipse at 50% 57%,#301800 10%,#52771a33 11%);",
    "background: repeating-radial-gradient(ellipse at 50% 58%,#301800 10%,#52771a33 11%);",
    "background: repeating-radial-gradient(ellipse at 50% 59%,#301800 10%,#52771a33 11%);",
    "background: repeating-radial-gradient(ellipse at 50% 60%,#301800 10%,#52771a33 11%);",
    "background: repeating-radial-gradient(ellipse at 50% 65%,#301800 10%,#52771a33 11%);",
    "background: repeating-linear-gradient(62deg, #001cff66 49%, #e5fe9d99 52%);",
    "background: repeating-linear-gradient(to bottom right,#b68685 60%,#cfbfbe33 55%,#938840cc 61%,#bb6e91 53%);",
    "background: repeating-linear-gradient(to top,#ffd277 50%,#e0cbb8 33%,#ffcbb8 53%,#e2c58b 51%,#c2ab9c 56%,#7edbdc4d 58%);",
    "background: repeating-linear-gradient(to top,#ffd277 50%,#e0cbb899 56%,#ffffb880 53%,#e2008be6 51%,#c2ab9c 56%,#7edbdc4d 58%);",
    "background:repeating-linear-gradient(to top,#83f2e180 88%,#bfad4b 90%);",
    "background:repeating-radial-gradient(ellipse at 45% 66%,#339ad0 10%,#cce7d64d 12%);",
    "background:repeating-radial-gradient(ellipse at 50% 50%,#e9ff2d 99%,#b84066 );",
    "background:repeating-radial-gradient(ellipse at 50% 0%,#e6ff2d 99%,#b86f93 );",
  ];

  let gradientTextDataPicks = [
    "background: -webkit-linear-gradient(#eee, #333); -webkit-background-clip: text;-webkit-text-fill-color: transparent;",
    "background:linear-gradient(90deg,#00d2ff 0%, #3a47d5 100%); -webkit-background-clip: text;-webkit-text-fill-color: transparent;",
    "background:repeating-radial-gradient( circle  at 60% 98%, rgba(83,138,214,1) 0%,rgba(134,231,214,1) 12% ) ; -webkit-background-clip: text;-webkit-text-fill-color: transparent;",
    "background:-webkit-linear-gradient(#fee140, #3a47d5); -webkit-background-clip:text; -webkit-text-fill-color: transparent;",
    "background:repeating-radial-gradient( circle  at right top, rgba(123,138,214,1) 0%,rgba(55,53,214,1) 12% ) ; -webkit-background-clip: text; -webkit-text-fill-color:transparent;",
    "background: linear-gradient(red, yellow, blue,orange);-webkit-background-clip: text; -webkit-text-fill-color: transparent;",
    "background: linear-gradient( to left, lime 28px, red 77%, cyan );-webkit-background-clip:text; -webkit-text-fill-color: transparent;",
    "background: linear-gradient(to left,pink 28px, red 77%, cyan);-webkit-background-clip: text; -webkit-text-fill-color: transparent;",
    "background: linear-gradient( to bottom left, gold 25%,purple 25%, red 50% );-webkit-background-clip: text;-webkit-text-fill-color: transparent;",
    "background: linear-gradient(to bottom left, cyan 50%, red 50%);-webkit-background-clip: text; -webkit-text-fill-color: transparent;",
    "background: linear-gradient( to left, brown 20%, red 30%, red 45%, cyan 55%,cyan 70%, yellow 80% ); -webkit-background-clip: text;-webkit-text-fill-color: transparent;",
    "background: linear-gradient(-45deg,#e7cc62 0%,#f8f880 20% ,#ff8b56 170%);; -webkit-background-clip: text;-webkit-text-fill-color: transparent;",
    "background: linear-gradient(to left,brown 20%, red 30%, red 45%, silver 55%, silver 70%, yellow 80% ); -webkit-background-clip: text;-webkit-text-fill-color: transparent;",
    "background:linear-gradient(to left, pink 20%, red 30% 45%, silver 55% 70%, yellow 80% );-webkit-background-clip: text; -webkit-text-fill-color:transparent;",
    "background: linear-gradient( to left, lime 25%, red 25%, red 50%,silver 50%, cyan 75%, yellow 75% );-webkit-background-clip: text;-webkit-text-fill-color: transparent;",
    "background: linear-gradient(to top, #c71d6f 0%, #d09693 100%);-webkit-background-clip: text;-webkit-text-fill-color: transparent;",
    "background: linear-gradient(90deg, #FAD961 0%, #F76B1C 100%);-webkit-background-clip: text;-webkit-text-fill-color: transparent;",
    "background: radial-gradient(circle at center center, rgba(225, 123, 233, 0.776),rgba(225, 123, 233, 0.776),rgb(234, 178, 12));-webkit-background-clip: text; -webkit-text-fill-color: transparent;",
  ];
</script>

<div id="my-nav-bar">
  <div id="title">
    <h1 style="">Colors Fun Gallery</h1>
  </div>
  <div id="main-menu">
    <ul>
      <li
        on:click={() => {
          activeView = 0;
        }}
        class:active-view={activeView === 0}
      >
        Colors Shade Groups
      </li>
      <li
        on:click={() => {
          activeView = 1;
        }}
        class:active-view={activeView === 1}
      >
        Gradient Background Groups
      </li>
      <li
        on:click={() => {
          activeView = 2;
        }}
        class:active-view={activeView === 2}
      >
        Gradient Text Picks
      </li>
      <li
        on:click={() => {
          activeView = 3;
        }}
        class:active-view={activeView === 3}
      >
        Color Mixing
      </li>
    </ul>
  </div>
</div>

<div class="my-column">
  <div class="my-row">
    {#if activeView === 0}
      <div class="my-row-cell one-cell-in-row">
        <p class="my-row-cell-caption">Colors Shade Groups</p>
        <div>
          <ColorShadeGroup
            groupName="Red Family"
            groupColor="red"
            groupData={redData}
          />

          <ColorShadeGroup
            groupName="Green Family"
            groupColor="green"
            groupData={greenData}
          />

          <ColorShadeGroup
            groupName="Blue Family"
            groupColor="blue"
            groupData={blueData}
          />

          <ColorShadeGroup
            groupName="Purple Family"
            groupColor="purple"
            groupData={purpleData}
          />
        </div>
      </div>
      <!-- enf of color shades -->
    {:else if activeView === 1}
      <div class="my-row-cell one-cell-in-row">
        <p class="my-row-cell-caption">Gradient Background Groups</p>
        <div>
          <GradientBackgroundGroup
            groupName="Gradient Background Group 1"
            groupColor="#ffffff55"
            groupGradient="linear-gradient(to bottom, #cfd9df 0%, #c467fa 100%);"
            groupData={gradientBackgroundDataGroup1}
          />

          <GradientBackgroundGroup
            groupName="Gradient Background Group 2"
            groupColor="#ffffff55"
            groupGradient="linear-gradient(-90deg,#85fddd 0%,#f48ae9 100%);"
            groupData={gradientBackgroundDataGroup2}
          />
          <GradientBackgroundGroup
            groupName="Gradient Background Group 3"
            groupColor="#ffffff55"
            groupGradient=" linear-gradient(45deg,#e7cc62 0%,#f8f880 20% ,#ff8b56 170%);"
            groupData={gradientBackgroundDataGroup3}
          />

          <GradientBackgroundGroup
            groupName="Gradient Background Group 4"
            groupColor="#ffffff55"
            groupGradient=" linear-gradient(to left,#fbbb7c 10%,#b3f1f1 44% ,#ffa0c9 98%);"
            groupData={gradientBackgroundDataGroup4}
          />

          <GradientBackgroundGroup
            groupName="Gradient Background Group 5"
            groupColor="#ffffff55"
            groupGradient="radial-gradient(at 50% 3%, rgb(122, 38, 206),rgb(28, 228, 182));"
            groupData={gradientBackgroundDataGroup5}
          />

          <GradientBackgroundGroup
            groupName="Gradient Background Group 6"
            groupColor="#ffffff55"
            groupGradient="radial-gradient( circle at center center, rgba(83,138,214,1) 0%,rgba(134,231,214,1) 12% ) ;"
            groupData={gradientBackgroundDataGroup6}
          />

          <GradientBackgroundGroup
            groupName="Gradient Background Picks"
            groupColor="#ffffff55"
            groupGradient="linear-gradient(90deg, #FDBB2D 0%, #3A1C71 100%)"
            groupData={gradientBackgroundDataPicks}
          />

          <GradientBackgroundGroup
            groupName="HOT Gradient Background Picks"
            groupColor="#ffffff55"
            groupGradient="repeating-linear-gradient(to top,#83f2e180 88%,#bfad4b 90%);"
            groupData={gradientHotBackgroundDataPicks}
          />
        </div>
      </div>
    {:else if activeView === 2}
      <div class="my-row-cell one-cell-in-row">
        <p class="my-row-cell-caption">Gradient Text Picks</p>
        <div>
          <GradientTextGroup
            groupName="Gradient Text Picks"
            groupColor="#ffffff55"
            groupGradient="linear-gradient(90deg, #FAD961 0%, #F76B1C 100%)"
            groupData={gradientTextDataPicks}
          />
        </div>
      </div>
    {:else if activeView === 3}
      <div class="my-row-cell one-cell-in-row">
        <p class="my-row-cell-caption">Color Mixing</p>
        <div>
          <ColorMixManager />
        </div>
      </div>

      <!-- if end -->
    {/if}
  </div>
</div>

<style>
  #my-nav-bar {
    position: fixed;
    top: 0;
    background-color: #000;
    background-blend-mode: multiply;
    width: 100%;
    height: 90px;
    padding: 4px;
    margin: 0px 0px 12px 0px;

    z-index: 9999;
  }

  #title > h1 {
    font-size: 56px;
    margin: 0;
    background: linear-gradient(
      to left,
      lime 25%,
      purple 25%,
      red 22%,
      silver 50%,
      cyan 75%,
      yellow 95%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    font-family: "Anton", sans-serif;
    letter-spacing: 3px;
    padding-left: 32px;
    text-shadow: rgba(255, 255, 255, 0.5) -1px -1px 1px,
      rgba(0, 0, 0, 0.5) 1px 1px 1px;
  }

  #main-menu {
    width: 99%;
    height: 42px;
    background: linear-gradient(
      to bottom,
      #f98490f3 10%,
      #3cffdbe0 44%,
      #e2800199 98%
    );
    margin: 0px auto;
    padding: 1px;
    bottom: 0;
    border: 2px solid gery;
    border-radius: 90px;
    box-shadow: -18px -17px 15px -15px rgba(0, 0, 0, 0.85) inset;
    -webkit-box-shadow: -18px -17px 15px -15px rgba(0, 0, 0, 0.85) inset;
    -moz-box-shadow: -18px -17px 15px -15px rgba(0, 0, 0, 0.85) inset;
  }

  #main-menu ul {
    list-style: none;
    display: flex;
    justify-content: center;
  }
  #main-menu ul li {
    /* background-color: #000; */
    background: linear-gradient(
      to bottom,
      #100909 5%,
      #a77b83 90%,
      #011539 93%
    );
    font-family: "Quicksand", sans-serif;
    font-weight: bold;
    letter-spacing: 2px;
    color: #fff;
    border-radius: 90px;
    padding: 6px 12px;
    margin: 2px 3px;
    cursor: pointer;
    box-shadow: -20px -13px 88px -10px rgba(0, 0, 0, 0.86);
    -webkit-box-shadow: -20px -13px 88px -10px rgba(0, 0, 0, 0.86);
    -moz-box-shadow: -20px -13px 88px -10px rgba(0, 0, 0, 0.86);
  }

  li.active-view {
    color: greenyellow;
    box-shadow: -20px -13px 88px -10px rgba(26, 239, 6, 0.864) inset;
    -webkit-box-shadow: -20px -13px 88px -10px rgba(26, 239, 6, 0.864) inset;
    -moz-box-shadow: -20px -13px 88px -10px rgba(26, 239, 6, 0.864) inset;
  }
</style>
